import {
  MessageDirection,
  MessageEvent,
  WebChatAfterHoursEvent,
  WebChatEndedEvent,
} from '@ucc/cc-common-ui';

import { WebChatAfterHoursMessageEvent, WebChatEnded, WebChatMessage } from './types';

export const toMessageEvent = (event: WebChatMessage): MessageEvent => ({
  id: event.key,
  // flip the direction as it is based on the agent point of view
  direction:
    event.direction === MessageDirection.INBOUND
      ? MessageDirection.OUTBOUND
      : MessageDirection.INBOUND,
  body: event.body,
  conversationId: '',
  ...(event.agent && {
    from: {
      id: event.agent?.key,
      firstName: event.agent?.firstName,
    },
  }),
  createdAt: event.sentAt,
  associatedFiles: event.associatedFiles,
});

export const toAfterHoursEvent = (
  event: WebChatAfterHoursMessageEvent
): WebChatAfterHoursEvent => ({
  id: event.eventIdentifier,
  conversationId: '',
  createdAt: event.sentAt,
  afterHoursMessage: event.afterHoursMessage,
});

export const toChatEndedEvent = (event: WebChatEnded): WebChatEndedEvent => ({
  id: event.eventIdentifier,
  performedBy: {
    id: '',
    firstName: event.agent?.firstName,
  },
  createdAt: event.sentAt,
});
